<template>
  <RIMomentoEscuela :escuela="2" titulo="Reporte RI al momento FAST" />
</template>

<script>
import RIMomentoEscuela from '@/views/kpi/RIMomentoEscuela.vue'

export default {
  name: 'RIMomentoFAST',
  components: { RIMomentoEscuela },
}
</script>
